import { render } from "./ConsentCheckboxItem.vue?vue&type=template&id=34a71d42"
import script from "./ConsentCheckboxItem.vue?vue&type=script&lang=js"
export * from "./ConsentCheckboxItem.vue?vue&type=script&lang=js"

import "./ConsentCheckboxItem.vue?vue&type=style&index=0&id=34a71d42&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__